import { useState, useEffect } from 'react';
import DatePicker from '../../components/DatePicker';
import { apiRequest } from '../../services/api';
import YeniFaturaModal from '../../components/YeniFaturaModal';
import { downloadExcel, printTable } from '../../utils/exportUtils';
import EmptyState from '../../components/EmptyState';
import DataTable, { Rozet } from '../../components/DataTable';

// ─── Sabitler ───────────────────────────────────────────────
var FATURA_TIPLERI   = ['Hepsi', 'e-Fatura', 'e-Arşiv'];
var GIB_DURUMLARI    = ['Hepsi', 'BAŞARILI', 'HATA', 'BEKLEMEDE', 'İPTAL'];

// ─── Yardımcılar ──────────────────────────────────────────────
function pad(n){ return String(n).padStart(2,'0'); }
function ayniBasi(ay){ var d=new Date(); d.setMonth(ay); d.setDate(1); return '01.'+pad(ay+1)+'.'+d.getFullYear(); }
function ayniSonu(ay){ var d=new Date(new Date().getFullYear(),ay+1,0); return pad(d.getDate())+'.'+pad(ay+1)+'.'+d.getFullYear(); }
var AYLAR=['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];

var GIB_BADGE = {
  'BAŞARILI':'bg-emerald-100 text-emerald-700',
  'HATA':'bg-rose-100 text-rose-700',
  'BEKLEMEDE':'bg-amber-100 text-amber-700',
  'İPTAL':'bg-slate-100 text-slate-500',
};

// ─── Detay Modal (Premium Yüzey) ──────────────────────────────────────────────
function DetayModal({ f, onKapat }) {
  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[70] flex items-center justify-center p-4" style={{ paddingTop: '80px' }}>
      <div className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-lg overflow-hidden animate-fade-in">
        <div className="px-8 py-6 bg-slate-50 flex items-center justify-between border-b border-slate-100">
          <div>
            <h2 className="text-xl font-black text-slate-800 tracking-tight">Fatura Detayı</h2>
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-1">{f.uuid}</p>
          </div>
          <button onClick={onKapat} className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition-all font-black">×</button>
        </div>
        <div className="px-8 py-6 space-y-4 text-sm">
          {[
            ['Fatura No', f.no],
            ['Tip', f.tip],
            ['Tarih / Saat', f.tarih + ' ' + f.saat],
            ['Alıcı', f.alici],
            ['TC / Vergi No', f.tcVergi],
            ['KDV Tutarı', <span className="font-mono text-slate-500">{Number(f.kdv).toFixed(2)} ₺</span>],
            ['Genel Toplam', <span className="text-xl font-black text-emerald-600">{Number(f.tutar).toFixed(2)} ₺</span>],
          ].map((r, i) => (
            <div key={i} className="flex justify-between items-center border-b border-slate-50 pb-3">
              <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{r[0]}</span>
              <span className="font-bold text-slate-700 text-right">{r[1]}</span>
            </div>
          ))}
          <div className="flex justify-between items-center pt-2">
            <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">GIB Durumu</span>
            <span className={`text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest ${GIB_BADGE[f.gibDurum] || 'bg-slate-100 text-slate-500'}`}>{f.gibDurum}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Ana Sayfa ────────────────────────────────────────────────
export default function GidenFaturalar() {
  var suankiAy = new Date().getMonth();
  var [ay, setAy] = useState(AYLAR[suankiAy]);
  var [bas, setBas] = useState(ayniBasi(suankiAy));
  var [bit, setBit] = useState(ayniSonu(suankiAy));
  var [fatTip, setFatTip] = useState('Hepsi');
  var [gibDurum, setGibDurum] = useState('Hepsi');
  var [aliciAra, setAliciAra] = useState('');
  var [faturaNoAra, setFaturaNoAra] = useState('');
  var [tumVeri, setTumVeri] = useState([]);
  var [yukleniyor, setYukleniyor] = useState(false);
  var [hata, setHata] = useState(null);
  var [detay, setDetay] = useState(null);
  var [yeniFaturaAcik, setYeniFaturaAcik] = useState(false);

  function isoToTarih(iso){ if(!iso) return ''; var d=new Date(iso); return pad(d.getDate())+'.'+pad(d.getMonth()+1)+'.'+d.getFullYear(); }
  function isoToSaat(iso){ if(!iso) return ''; var d=new Date(iso); return pad(d.getHours())+':'+pad(d.getMinutes()); }

  async function apidenYukle(basTarih, bitTarih) {
    setYukleniyor(true); setHata(null);
    try {
      function toIso(s){ var p=s.split('.'); return p[2]+'-'+p[1]+'-'+p[0]; }
      var data = await apiRequest(`efatura/giden?baslangic=${toIso(basTarih)}&bitis=${toIso(bitTarih)}`);
      var mapped = (data||[]).map((f,i) => ({
        id: f.uuid || String(i),
        uuid: f.uuid || '',
        no: f.faturaNo || '',
        tip: f.faturaTipi || 'e-Fatura',
        tarih: isoToTarih(f.tarih),
        saat: isoToSaat(f.tarih),
        alici: f.aliciAdi || '',
        tcVergi: f.aliciVkn || '',
        tutar: f.tutar || 0,
        kdv: f.kdvTutari || 0,
        gibDurum: f.durum || 'BEKLEMEDE',
        aliciDurum: '—',
      }));
      setTumVeri(mapped);
    } catch(e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }

  useEffect(() => { apidenYukle(bas, bit); }, []); // eslint-disable-line

  function ayDegis(v){ setAy(v); var i=AYLAR.indexOf(v); setBas(ayniBasi(i)); setBit(ayniSonu(i)); }
  function filtrele(){ apidenYukle(bas, bit); }
  function temizle(){
    var b=ayniBasi(suankiAy), e=ayniSonu(suankiAy);
    setAy(AYLAR[suankiAy]); setBas(b); setBit(e);
    setFatTip('Hepsi'); setGibDurum('Hepsi');
    setAliciAra(''); setFaturaNoAra('');
    apidenYukle(b, e);
  }
  

  var liste = tumVeri.filter(f => {
    if(fatTip!=='Hepsi'&&f.tip!==fatTip) return false;
    if(gibDurum!=='Hepsi'&&f.gibDurum!==gibDurum) return false;
    if(aliciAra&&!f.alici.toLocaleLowerCase('tr-TR').includes(aliciAra.toLocaleLowerCase('tr-TR'))) return false;
    if(faturaNoAra&&!f.no.toLowerCase().includes(faturaNoAra.toLowerCase())) return false;
    return true;
  // Sıralama DataTable içinde; burada en yeni fatura üste alınır.
  }).sort((a,b) => String(b.tarih||'').localeCompare(String(a.tarih||''),'tr',{numeric:true}));

  var toplamTutar = liste.reduce((a,f)=>a+f.tutar,0);
  var toplamKdv   = liste.reduce((a,f)=>a+f.kdv,0);
  var basarili    = liste.filter(f=>f.gibDurum==='BAŞARILI' || f.gibDurum?.toUpperCase().includes('ONAY')).length;
  var bekleyen    = liste.filter(f=>f.gibDurum==='BEKLEMEDE' || f.gibDurum?.toUpperCase().includes('GÖNDER')).length;

  var SEL="w-full bg-slate-50 border-2 border-transparent focus:border-indigo-400 rounded-xl px-4 py-3 text-xs font-black text-slate-700 outline-none uppercase tracking-widest transition-all appearance-none cursor-pointer";
  var INP="w-full bg-slate-50 border-2 border-transparent focus:border-indigo-400 rounded-xl px-4 py-3 text-xs font-black text-slate-700 outline-none uppercase tracking-widest transition-all";
  var LBL="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 pl-1";

  return (
    <div className="p-4 sm:p-8 space-y-8 animate-fade-in pb-24">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div>
          <h1 className="text-4xl font-black text-slate-800 tracking-tight">Giden Faturalar</h1>
          <p className="text-slate-500 font-bold mt-1 uppercase text-[10px] tracking-[0.2em]">EDM / GİB E-Fatura Çıkış Portalı</p>
        </div>
        <button onClick={() => setYeniFaturaAcik(true)} className="bg-gradient-to-r from-indigo-500 to-blue-600 hover:from-indigo-600 hover:to-blue-700 text-white font-black text-[11px] uppercase tracking-[0.2em] px-8 py-4 rounded-2xl shadow-xl shadow-indigo-500/30 transition-all active:scale-95 flex items-center justify-center gap-3">
          <span className="text-xl">🧾</span> Yeni Fatura Kes
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          { label: 'TOPLAM FATURA', val: liste.length, c: 'from-slate-700 to-slate-900', i: '📑' },
          { label: 'BAŞARILI', val: basarili, c: 'from-emerald-400 to-teal-500', i: '✅' },
          { label: 'BEKLEMEDE / HATA', val: bekleyen, c: 'from-amber-400 to-orange-500', i: '⏳' },
          { label: 'TOPLAM KESİLEN', val: toplamTutar.toLocaleString('tr-TR',{minimumFractionDigits:2})+' ₺', c: 'from-indigo-500 to-purple-600', i: '💰' },
        ].map((s, i) => (
          <div key={i} className={`bg-gradient-to-br ${s.c} p-6 rounded-[2.5rem] text-white shadow-xl relative overflow-hidden group transition-all hover:scale-105`}>
            <span className="absolute top-4 right-4 text-4xl opacity-20 group-hover:scale-125 transition-transform">{s.i}</span>
            <p className="text-[10px] font-black tracking-widest uppercase opacity-70 mb-1">{s.label}</p>
            <h3 className="text-2xl sm:text-3xl font-black tracking-tighter">{s.val}</h3>
          </div>
        ))}
      </div>

      {/* Filter Bar */}
      <div className="bg-white rounded-[2.5rem] shadow-xl border border-slate-100 p-6 sm:p-8">
        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-50">
          <span className="text-2xl">🔍</span>
          <h3 className="text-sm font-black text-slate-700 uppercase tracking-widest">Filtreler</h3>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 items-end">
          <div className="col-span-2 sm:col-span-1">
            <label className={LBL}>Ay</label>
            <div className="relative">
              <select value={ay} onChange={e => ayDegis(e.target.value)} className={SEL}>
                {AYLAR.map(a => <option key={a}>{a}</option>)}
              </select>
            </div>
          </div>
          <div className="col-span-2 sm:col-span-1">
            <label className={LBL}>Fatura Tipi</label>
            <select value={fatTip} onChange={e => setFatTip(e.target.value)} className={SEL}>
              {FATURA_TIPLERI.map(v => <option key={v}>{v}</option>)}
            </select>
          </div>
          <div className="col-span-2 sm:col-span-1">
            <label className={LBL}>GİB Durumu</label>
            <select value={gibDurum} onChange={e => setGibDurum(e.target.value)} className={SEL}>
              {GIB_DURUMLARI.map(v => <option key={v}>{v}</option>)}
            </select>
          </div>
          <div className="col-span-2 sm:col-span-2">
            <label className={LBL}>Alıcı Adı / Ünvan</label>
            <input value={aliciAra} onChange={e => setAliciAra(e.target.value)} className={INP} placeholder="Arama..." />
          </div>
          <div className="col-span-2 sm:col-span-1">
            <button onClick={filtrele} className="w-full bg-slate-800 hover:bg-black text-white font-black text-[10px] uppercase tracking-widest py-3.5 rounded-xl shadow-lg transition-all active:scale-95">SORGULA</button>
          </div>
        </div>
      </div>

      {/* Error */}
      {hata && <div className="bg-rose-50 border-2 border-rose-100 text-rose-700 p-4 rounded-2xl text-sm font-bold animate-fade-in">⚠️ {hata}</div>}

      {/* Table Action Bar */}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 bg-slate-50 p-4 rounded-3xl border border-slate-100">
        <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest pl-2">
          {liste.length} Fatura Bulundu
        </p>
        <div className="flex gap-2">
          <button onClick={() => downloadExcel('giden-faturalar', 'Giden Faturalar', ['Fatura No','Tarih','Saat','Alıcı','TC/Vergi No','Tip','Tutar (₺)','KDV (₺)','GİB Durumu'], liste.map(f => [f.no, f.tarih, f.saat, f.alici, f.tcVergi, f.tip, Number(f.tutar).toFixed(2), Number(f.kdv).toFixed(2), f.gibDurum]))} className="bg-white border-2 border-slate-100 hover:border-slate-300 text-slate-600 font-black text-[9px] uppercase tracking-widest px-6 py-2 rounded-xl transition-all shadow-sm">EXCEL</button>
          <button onClick={() => printTable('Giden Faturalar', ['Fatura No','Tarih','Saat','Alıcı','TC/Vergi No','Tip','Tutar (₺)','KDV (₺)','GİB Durumu'], liste.map(f => [f.no, f.tarih, f.saat, f.alici, f.tcVergi, f.tip, Number(f.tutar).toFixed(2), Number(f.kdv).toFixed(2), f.gibDurum]), `${liste.length} fatura | ${bas} – ${bit}`)} className="bg-white border-2 border-slate-100 hover:border-slate-300 text-slate-600 font-black text-[9px] uppercase tracking-widest px-6 py-2 rounded-xl transition-all shadow-sm">YAZDIR</button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-[3rem] shadow-2xl border border-slate-100 overflow-x-auto custom-scrollbar">
        <DataTable
          anahtarAlan="id"
          satirlar={yukleniyor ? [] : liste}
          enAzGenislik="800px"
          bosIkon="🧾"
          bosMetin={yukleniyor ? 'EDM\'den yükleniyor…' : 'Kayıt bulunamadı'}
          kolonlar={[
            {
              anahtar: 'no', baslik: 'Fatura No', siralanir: true, filtrelenir: true,
              ciz: f => (
                <>
                  <div className="font-black text-slate-700 text-xs">{f.no || '-'}</div>
                  <div className="font-mono text-[9px] text-slate-400 uppercase mt-1 opacity-50">{f.uuid || '-'}</div>
                </>
              ),
            },
            {
              anahtar: 'tarih', baslik: 'Tarih', siralanir: true, filtrelenir: true,
              ciz: f => (
                <>
                  <div className="font-black text-slate-700 text-xs">{f.tarih}</div>
                  <div className="font-black text-slate-400 text-[9px] mt-1">{f.saat}</div>
                </>
              ),
            },
            {
              anahtar: 'alici', baslik: 'Alıcı', siralanir: true, filtrelenir: true,
              ciz: f => (
                <>
                  <div className="font-black text-slate-800 text-xs truncate max-w-[200px]">{f.alici}</div>
                  <div className="font-black text-slate-400 text-[10px] mt-1">{f.tcVergi}</div>
                </>
              ),
            },
            {
              anahtar: 'tip', baslik: 'Tip', hizala: 'orta', siralanir: true,
              ciz: f => <Rozet renk={f.tip === 'e-Fatura' ? 'indigo' : 'amber'}>{f.tip}</Rozet>,
            },
            {
              anahtar: 'tutar', baslik: 'Tutar', hizala: 'sag', siralanir: true,
              ciz: f => (
                <>
                  <div className="font-black text-slate-800 text-sm">{Number(f.tutar).toFixed(2)} ₺</div>
                  <div className="font-black text-slate-400 text-[9px] mt-1">KDV: {Number(f.kdv).toFixed(2)} ₺</div>
                </>
              ),
            },
            {
              anahtar: 'gibDurum', baslik: 'GİB Durum', hizala: 'orta', siralanir: true, filtrelenir: true,
              ciz: f => (
                <span className={'px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest ' +
                  (GIB_BADGE[f.gibDurum] || 'bg-slate-100 text-slate-500')}>
                  {f.gibDurum}
                </span>
              ),
            },
            {
              anahtar: 'islem', baslik: 'İşlem', hizala: 'orta',
              ciz: f => (
                <button onClick={() => setDetay(f)}
                  className="bg-white border-2 border-slate-100 hover:border-indigo-400 hover:text-indigo-600 text-slate-400 font-black text-[9px] uppercase tracking-widest px-4 py-2 rounded-xl transition-all">
                  Detay
                </button>
              ),
            },
          ]}
        />
      </div>

      {detay && <DetayModal f={detay} onKapat={() => setDetay(null)}/>}
      {yeniFaturaAcik && <YeniFaturaModal onKapat={() => { setYeniFaturaAcik(false); apidenYukle(bas, bit); }}/>}
    </div>
  );
}